
const DataTyteTemplate = {
	"IsSeparateByWareHouse": {
		"Type": "boolean"
	},
	"OrigAllowances": {
		"Type": "number"
	},
	"IsAutoSaleOut": {
		"Type": "boolean"
	},
	"DiscountRate": {
		"Type": "number"
	},
	"OrigPreReceiveAmount": {
		"Type": "number"
	},
	"ID": {
		"Type": "number"
	},
	"RecivingMaturity": {
		"Type": "date"
	},
	"VoucherDate": {
		"Type": "date"
	},
	"OrigSettleAmount": {
		"Type": "number"
	},
	"Code": {
		"Type": "string"
	},
	"LinkMan": {
		"Type": "string"
	},
	"IdsourceVoucherType": {
		"Type": "number"
	},
	"ContactPhone": {
		"Type": "string"
	},
	"IsBeforeSystemInuse": {
		"Type": "boolean"
	},
	"IsAutoGenerateInvoice": {
		"Type": "boolean"
	},
	"Address": {
		"Type": "string"
	},
	"IsNoModify": {
		"Type": "string"
	},
	"Memo": {
		"Type": "string"
	},
	"OrigTaxAmount": {
		"Type": "number"
	},
	"Maker": {
		"Type": "string"
	},
	"IdbusinessType": {
		"Type": "number"
	},
	"ExternalCode": {
		"Type": "string"
	},
	"ExternalVoucherCode": {
		"Type": "string"
	},
	"CustomerPhone": {
		"Type": "string"
	},
	"ts": {
		"Type": "string"
	},
	"DynamicPropertyKeys": {
		"Type": "array"
	},
	"DynamicPropertyValues": {
		"Type": "array"
	},
	"IsUseInventoryWarehouse": {
		"Type": "boolean"
	},
	"Credit": {
		"Type": "boolean"
	},
	"Warehouse": {
		"Type": "reference",
		"Fields": {
			"Code": {
				"Type": "string"
			},
			"Name": {
				"Type": "string"
			},
			"ID": {
				"Type": "number"
			}
		}
	},
	"Project": {
		"Type": "reference",
		"Fields": {
			"Name": {
				"Type": "string"
			},
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			}
		}
	},
	"DeliveryMode": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			},
			"Name": {
				"Type": "string"
			}
		}
	},
	"VoucherState": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			},
			"Name": {
				"Type": "string"
			}
		}
	},
	"IsCancel": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			},
			"Name": {
				"Type": "string"
			}
		}
	},
	"InvoiceType": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			},
			"Name": {
				"Type": "string"
			}
		}
	},
	"Customer": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Name": {
				"Type": "string"
			},
			"Code": {
				"Type": "string"
			}
		}
	},
	"SettleCustomer": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Name": {
				"Type": "string"
			},
			"Code": {
				"Type": "string"
			},
			"ARBalance": {
				"Type": "number"
			}
			
		}
	},
	"Department": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Name": {
				"Type": "string"
			},
			"Code": {
				"Type": "string"
			}
		}
	},
	"Clerk": {
		"Type": "reference",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			},
			"Name": {
				"Type": "string"
			},
			"MobilePhoneNo": {
				"Type": "string"
			}
		}
	},
	"SaleDeliveryDetails": {
		"Type": "array",
		"Fields": {
			"freeitem0": {
				"Type": "string"
			},
			"freeitem1": {
				"Type": "string"
			},
			"ProductionDate": {
				"Type": "date"
			},
			"IsPromotionPresent": {
				"Type": "boolean"
			},
			"PromotionPresentVoucherID": {
				"Type": "number"
			},
			"PromotionPresentTypeID": {
				"Type": "number"
			},
			"PromotionSingleTypeID": {
				"Type": "number"
			},
			"PromotionSingleVoucherID": {
				"Type": "number"
			},
			"PriceStrategySchemeNames": {
				"Type": "string"
			},
			"PriceStrategyTypeName": {
				"Type": "string"
			},
			"PromotionPresentVoucherCode": {
				"Type": "string"
			},
			"PromotionSingleVoucherCode": {
				"Type": "string"
			},
			"PromotionPresentGroupID": {
				"Type": "string"
			},
			"PromotionSingleGroupID": {
				"Type": "string"
			},
			"PriceStrategyTypeId": {
				"Type": "number"
			},
			"PriceStrategySchemeIds": {
				"Type": "string"
			},
			"PromotionVoucherCodes": {
				"Type": "string"
			},
			"Retailprice": {
				"Type": "number"
			},
			"SourceVoucherDetailTs": {
				"Type": "string"
			},
			"OrigPrice": {
				"Type": "number"
			},
			"Quantity": {
				"Type": "number"
			},
			"QuantityExt1": {
				"Type": "number"
			},
			"QuantityExt2": {
				"Type": "number"
			},
			"QuantityExt3": {
				"Type": "number"
			},
			"QuantityExt4": {
				"Type": "number"
			},
			"QuantityExt5": {
				"Type": "number"
			},
			"UnitExchangeRate": {
				"Type": "number"
			},
			"CompositionQuantity": {
				"Type": "string"
			},
			"SourceVoucherDetailId": {
				"Type": "number"
			},
			"SaleOrderCode": {
				"Type": "string"
			},
			"IsNoModify": {
				"Type": "string"
			},
			"SourceVoucherTs": {
				"Type": "string"
			},
			"Code": {
				"Type": "string"
			},
			"Batch": {
				"Type": "string"
			},
			"InventoryBarCode": {
				"Type": "string"
			},
			"SaleOrderId": {
				"Type": "number"
			},
			"ID": {
				"Type": "number"
			},
			"DiscountRate": {
				"Type": "number"
			},
			"IdsourceVoucherType": {
				"Type": "number"
			},
			"OrigTaxAmount": {
				"Type": "number"
			},
			"SaleOrderDetailId": {
				"Type": "number"
			},
			"SourceVoucherId": {
				"Type": "number"
			},
			"SourceVoucherCode": {
				"Type": "string"
			},
			"OrigTaxPrice": {
				"Type": "number"
			},
			"IsPresent": {
				"Type": "boolean"
			},
			"ExpiryDate": {
				"Type": "date"
			},
			"DetailMemo": {
				"Type": "string"
			},
			"LatestCost": {
				"Type": "number"
			},
			"LatestPOrigTaxPrice": {
				"Type": "number"
			},
			"LowestSalePrice": {
				"Type": "number"
			},
			"LatestSaleOrigTaxPrice": {
				"Type": "number"
			},
			"PromotionBatchMemo": {
				"Type": "string"
			},
			"PromotionPresentBatchInfo": {
				"Type": "string"
			},
			"PromotionPresentBatchType": {
				"Type": "string"
			},
			"PromotionPriceBatchInfo": {
				"Type": "string"
			},
			"PromotionPriceBatchType": {
				"Type": "string"
			},
			"ts": {
				"Type": "string"
			},
			"DynamicPropertyKeys": {
				"Type": "array"
			},
			"DynamicPropertyValues": {
				"Type": "array"
			},
			"ExistingQuantity": {
				"Type": "string"
			},
			"AvailableQuantity": {
				"Type": "string"
			},
			"Warehouse": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			"Project": {
				"Type": "reference",
				"Fields": {
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					},
					"Code": {
						"Type": "string"
					}
				}
			},
			"Inventory": {
				"Type": "reference",
				"Fields": {
					"priuserdefnvc1": {
						"Type": "string"
					},
					"priuserdefnvc2": {
						"Type": "string"
					},
					"priuserdefnvc3": {
						"Type": "string"
					},
					"priuserdefnvc4": {
						"Type": "string"
					},
					"priuserdefnvc5": {
						"Type": "string"
					},
					"priuserdefdecm1": {
						"Type": "number"
					},
					"Expired": {
						"Type": "number"
					},
					"Code": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					},
					"IsQualityPeriod": {
						"Type": "boolean"
					},
					"Specification": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ExpiredUnit": {
						"Type": "reference",
						"Fields": {
							"ID": {
								"Type": "number"
							},
							"Code": {
								"Type": "string"
							},
							"Name": {
								"Type": "string"
							}
						}
					}
				}
			},
			"Unit": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			"UnitExt1": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			"UnitExt2": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			"UnitExt3": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			"UnitExt4": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			"UnitExt5": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			
			"RefundDifferenceFlag": {
				"Type": "reference",
				"Fields": {
					"ID": {
						"Type": "number"
					},
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					}
				}
			}
		}
	},
	"SaleDeliverySettlements": {
		"Type": "array",
		"Fields": {
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			},
			"SettleStyle": {
				"Type": "reference",
				"Fields": {
					"Code": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					},
					"Name": {
						"Type": "string"
					}
				}
			},
			"BankAccount": {
				"Type": "reference",
				"Fields": {
					"ID": {
						"Type": "number"
					},
					"Name": {
						"Type": "string"
					},
					"Code": {
						"Type": "string"
					}
				}
			}
		}
	},
	"SaleDeliveryPreReceives": {
		"Type": "array",
		"Fields": {
			"Ts": {
				"Type": "string"
			},
			"idvoucherType": {
				"Type": "number"
			},
			"ID": {
				"Type": "number"
			},
			"Code": {
				"Type": "string"
			},
			"VoucherID": {
				"Type": "number"
			},
			"VoucherDate": {
				"Type": "date"
			},
			"VoucherCode": {
				"Type": "string"
			},
			"OrigAmount": {
				"Type": "number"
			},
			"OrigNoCancelAmount": {
				"Type": "number"
			},
			"OrigCancelAmount": {
				"Type": "number"
			},
			"Person": {
				"Type": "reference",
				"Fields": {
					"ID": {
						"Type": "number"
					},
					"Code": {
						"Type": "string"
					},
					"Name": {
						"Type": "string"
					}
				}
			},
			"Project": {
				"Type": "reference",
				"Fields": {
					"Name": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					},
					"Code": {
						"Type": "string"
					}
				}
			},
			"VoucherType": {
				"Type": "reference",
				"Fields": {
					"Name": {
						"Type": "string"
					},
					"Code": {
						"Type": "string"
					},
					"ID": {
						"Type": "number"
					}
				}
			},
			"Department": {
				"Type": "reference",
				"Fields": {
					"ID": {
						"Type": "number"
					},
					"Name": {
						"Type": "string"
					},
					"Code": {
						"Type": "string"
					}
				}
			}
		}
	}
};


const UITemplate ={
	"Template": [{
		"TemplateName": "SaleDelivery",
		"Ts": "10802180",
		"Voucher": {
			"TabField": ["ID", "Name", "IsEmptyFiledHide", "IsDetail"],
			"TabValue": [
				[42, "SaleDeliveryHead", true, false],
				[69, "SaleDeliveryDetails", false, true],
				[70, "InventoryDetails", false, true],
				[71, "InventoryReturnDetails", false, true]
			],
			"GroupField": ["ID", "Name", "OrderIndex"],
			"GroupValue": [
				[209, "BaseInfo", 1]
			],
			"TemplateField": ["ID", "Name", "Title", "FieldName", "ControlType", "FieldType", "ReadOnly", "AllowNone", "MaxLength", "Precision", "EnumName", "RefDTOName", "RefShowField", "RefDataSource", "RefWhere", "DefaultValue", "RowWidth", "IsNegativeFormat", "TabID", "GroupID", "IsTitle", "IsRecord", "Format", "RelationFields", "IsDetail", "Expression"],
			"TemplateValue": [
				[1419, "Customer", "客户", "Customer", "RefComplexBox", "DTO", false, false, 100, 3, "", "PartnerDTO", "", "RefPartnerDTO", null, "", 0.00, false, 42, 209, false, false, "", "", false, null],
				[1415, "Memo", "备注", "Memo", "TextBox", "String", false, true, 200, 3, "", "", "", "RefDtoName", null, "", 0.00, false, 42, 209, false, false, "", "", false, null],
				[1418, "SettleCustomer_ARBalance", "应收余额", "ARBalance", "NumTextBox", "Decimal", true, true, 13, 2, "", "", "", "", null, "", 0.00, false, 42, 209, false, false, "", "SettleCustomer", false, null],
				[1418, "DiscountRate", "整单折扣", "DiscountRate", "PercentTextBox", "Decimal", false, true, 13, 2, "", "", "", "", null, "", 0.00, false, 42, 209, false, false, "", "SettleCustomer", false, null],
				[1417, "Warehouse", "仓库", "Warehouse", "RefComplexBox", "DTO", false, true, 0, 3, "", "WarehouseDTO", "", "MBRefWarehouseDTO", "Key@Key_RefWarehouseDTO_0002", "", 0.00, false, 42, 209, false, true, "", "", false, null],
				[1425, "VoucherDate", "单据日期", "VoucherDate", "DateDropDown", "DateTime", false, false, 48, 3, "", "", "", "RefDtoName", null, "", 0.00, false, 42, 209, false, false, "", "", false, null],
				[1428, "SettleCustomer", "结算客户", "SettleCustomer", "RefComplexBox", "DTO", false, false, 0, 3, "", "PartnerDTO", "", "RefPartnerDTO", null, "", 0.00, false, 42, 209, false, false, "", "", false, null],
				[1422, "Address", "送货地址", "Address", "TextComboBox", "DTO", false, true, 200, 3, "", "PartnerAddressDTO", "ShipmentAddress", "MBRefPartnerAddressDTO_ShipmentAddress", "Key@Key_RefPartnerAddressDTO_0002", "", 0.00, false, 42, 209, false, false, "", "", false, null],
				[1457, "InvoiceType", "票据类型", "InvoiceType", "ComboBox", "DTO", false, false, 1, 3, "", "", "", "", null, "0", 0.00, false, 42, 61, false, false, "", "", false, null],
				[1427, "Project", "项目", "Project", "RefComplexBox", "DTO", false, true, 0, 3, "", "ProjectDTO", "", "MBRefProjectDTO", "Key@Key_ProjectOnlyTree_0001", "", 0.00, false, 42, 209, false, false, "", "", false, null],
				[1455, "IsAutoSaleOut", "自动生成出库单", "IsAutoSaleOut", "CheckBox", "Bool", false, true, 1, 3, "", "", "", "", null, "0", 0.00, false, 42, 61, false, true, "", "", false, null],
				[1456, "IsUseInventoryWarehouse", "录入存货时优先取默认仓库", "IsUseInventoryWarehouse", "CheckBox", "Bool", false, true, 1, 3, "", "", "", "", null, "0", 0.00, false, 42, 61, false, true, "", "", false, null],
				[3205, "Inventory", "存货名称", "Inventory", "RefComplexBox", "DTO", false, false, 200, 2, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3196, "Inventory_Code", "存货编码", "Code", "RefComplexBox", "String", false, false, 50, 2, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3198, "Inventory_Specification", "规格型号", "Specification", "TextBox", "String", true, true, 200, 2, "", "", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3200, "InventoryBarCode", "条形码", "InventoryBarCode", "RefComboBox", "String", true, true, 128, 2, "", "InvBarCodeDTO", "", "RefInvBarCodeDTO", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3233, "Inventory_priuserdefdecm1", "存货数值", "priuserdefdecm1", "TextBox", "Decimal", true, true, 100, 2, "", "InventoryDTO", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3230, "Inventory_priuserdefnvc1", "存货字符1", "priuserdefnvc1", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3231, "Inventory_priuserdefnvc2", "存货字符2", "priuserdefnvc2", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3235, "Inventory_priuserdefnvc3", "存货字符3", "priuserdefnvc3", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3229, "Inventory_priuserdefnvc4", "存货字符4", "priuserdefnvc4", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3228, "Inventory_priuserdefnvc5", "存货字符5", "priuserdefnvc5", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3203, "ExistingQuantity", "现存量", "ExistingQuantity", "NumTextBox", "String", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3204, "AvailableQuantity", "可用量", "AvailableQuantity", "NumTextBox", "String", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3241, "freeitem0", "颜色", "freeItem0", "RefComplexBox", "String", false, true, 50, 2, "enumfreeitem0", "", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3242, "freeitem1", "尺码", "freeItem1", "RefComplexBox", "String", false, true, 50, 2, "enumfreeitem1", "", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3194, "Unit", "销售单位", "Unit", "RefComboBox", "DTO", false, false, 0, 2, "", "UnitDTO", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3201, "Warehouse", "仓库", "Warehouse", "DropDownComboBox", "DTO", false, true, 0, 2, "", "WarehouseDTO", "", "MBRefWarehouseDTO", "Key@Key_RefWarehouseDTO_0002", "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "Quantity", "数量", "Quantity", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "QuantityExt1", "数量1", "QuantityExt1", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "QuantityExt2", "数量2", "QuantityExt2", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "QuantityExt3", "数量3", "QuantityExt3", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "QuantityExt4", "数量4", "QuantityExt4", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "QuantityExt5", "数量5", "QuantityExt5", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "UnitExchangeRate", "换算率", "UnitExchangeRate", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3207, "Retailprice", "零售价", "Retailprice", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "Retailprice", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3211, "LowestSalePrice", "最低售价", "LowestSalePrice", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3209, "LatestCost", "结存成本", "LatestCost", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3210, "LatestSaleOrigTaxPrice", "最新售价", "LatestSaleOrigTaxPrice", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3199, "IsPresent", "赠品", "IsPresent", "CheckBox", "Bool", false, true, 1, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3195, "OrigTaxPrice", "单价", "OrigTaxPrice", "NumTextBox", "Decimal", false, true, 9, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "OrigPrice", "报价", "OrigPrice", "NumTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3197, "DiscountRate", "折扣率", "DiscountRate", "PercentTextBox", "Decimal", false, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3202, "OrigTaxAmount", "金额", "OrigTaxAmount", "NumTextBox", "Decimal", false, true, 13, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3208, "DetailMemo", "备注", "DetailMemo", "TextBox", "String", false, true, 200, 2, "", "", "", "", null, "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3206, "Project", "项目", "Project", "RefComplexBox", "DTO", false, true, 0, 2, "", "ProjectDTO", "", "MBRefProjectDTO", "Key@Key_ProjectOnlyTree_0001", "", 100.00, false, 69, 0, false, false, "", null, true, null],
				[3250, "Inventory_Code", "存货编码", "Code", "RefComplexBox", "String", false, false, 50, 2, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3257, "Inventory", "存货名称", "Inventory", "RefComplexBox", "DTO", false, false, 200, 2, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3258, "Inventory_ImageFile", "存货图片", "ImageFile", "ImageColumn", "String", true, true, 500, 2, "", "", "ImageFile", "", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3251, "Quantity", "数量", "Quantity", "NumTextBox", "Decimal", false, false, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3249, "OrigTaxPrice", "单价", "OrigTaxPrice", "NumTextBox", "Decimal", false, true, 9, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3255, "ExistingQuantity", "现存量", "ExistingQuantity", "NumTextBox", "Decimal", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3256, "AvailableQuantity", "可用量", "AvailableQuantity", "NumTextBox", "Decimal", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3248, "Unit", "销售单位", "Unit", "RefComboBox", "DTO", false, false, 0, 2, "", "UnitDTO", "", "RefDtoName", null, "", 100.00, false, 70, 0, false, false, "", null, true, null],
				[3271, "Inventory", "存货名称", "Inventory", "RefComplexBox", "DTO", false, false, 200, 2, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 100.00, false, 71, 0, false, false, "", null, true, null],
				[3263, "Unit", "销售单位", "Unit", "RefComboBox", "DTO", false, false, 0, 2, "", "UnitDTO", "", "RefDtoName", null, "", 100.00, false, 71, 0, false, false, "", null, true, null],
				[3265, "Quantity", "数量", "Quantity", "NumTextBox", "Decimal", false, false, 11, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 71, 0, false, false, "", null, true, null],
				[3268, "OrigTaxAmount", "含税金额", "OrigTaxAmount", "NumTextBox", "Decimal", true, false, 13, 2, "", "", "", "RefDtoName", null, "", 100.00, false, 71, 0, false, false, "", null, true, null]
			]
		},
		"PrintTempalte": {
			"Name": "SaleDeliveryDTO",
			"IsEmptyFiledHide": true,
			"PrinterType": "58mm",
			"PrintCount": 1,
			"GroupField": ["ID", "Name", "OrderIndex"],
			"GroupValue": [
				[13, "Head", 1],
				[14, "Body", 2],
				[15, "Foot", 3]
			],
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["Customer_Name", "客户", "string", true, false, 100.00, 0, 13, false],
				["Customer_Code", "客户编码", "string", true, false, 100.00, 0, 13, false],
				["CustomerPhone", "客户电话", "string", true, false, 100.00, 0, 13, false],
				["Address", "到货地址", "string", true, false, 100.00, 0, 13, false],
				["LinkMan", "联系人", "string", true, false, 100.00, 0, 13, false],
				["ContactPhone", "联系电话", "string", true, false, 100.00, 0, 13, false],
				["Code", "单号", "string", true, false, 100.00, 0, 13, false],
				["VoucherDate", "日期", "datetime", true, false, 100.00, 0, 13, false],
				["SettleCustomer_Name", "结算客户", "string", true, false, 100.00, 0, 13, false],
				["Inventory_Name", "存货名称", "string", true, true, 100.00, 0, 14, false],
				["Unit_Name", "单位", "string", true, false, 100.00, 0, 14, false],
				["Quantity", "数量", "decimal", true, false, 100.00, 2, 14, false],
				["OrigTaxPrice", "单价", "decimal", true, false, 100.00, 2, 14, false],
				["OrigTaxAmount", "金额", "decimal", true, false, 100.00, 2, 14, false],
				["TotalQuantity", "总数量", "decimal", true, false, 100.00, 2, 15, false],
				["OrigTaxAmount", "总金额", "decimal", true, false, 100.00, 2, 15, false],
				["Memo", "备注", "string", true, false, 100.00, 0, 15, false],
				["PrintDate", "打印日期", "datetime", true, false, 100.00, 0, 15, false],
				["QRCode", "单据编号", "string", true, false, 100.00, 0, 15, false],
				["Sign", "客户签字", "string", true, false, 100.00, 0, 15, false]
			]
		},
		"RefSetTempalte": [{
			"Name": "MBRefPartnerAddressDTO_ShipmentAddress",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["TelephoneNo", "座机", "string", false, false, 50.00, 0, 0, false],
				["MobilePhone", "手机", "string", false, false, 50.00, 0, 0, false],
				["DeliveryMode.Name", "运输方式", "string", false, false, 50.00, 0, 0, false]
			]
		}, {
			"Name": "MBRefProjectDTO",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["Code", "项目编码", "string", false, false, 50.00, 0, 0, false],
				["class.Name", "所属分类", "string", false, false, 50.00, 0, 0, false]
			]
		}, {
			"Name": "MBRefWarehouseDTO",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": []
		}]
	}, {
		"TemplateName": "SaleOrder",
		"Ts": "10801689",
		"Voucher": {
			"TabField": ["ID", "Name", "IsEmptyFiledHide", "IsDetail"],
			"TabValue": [
				[41, "SaleOrderHead", true, false],
				[66, "SaleOrderDetails", false, true],
				[67, "InventoryDetails", false, true],
				[68, "InventoryReturnDetails", false, true]
			],
			"GroupField": ["ID", "Name", "OrderIndex"],
			"GroupValue": [
				[208, "BaseInfo", 1]
			],
			"TemplateField": ["ID", "Name", "Title", "FieldName", "ControlType", "FieldType", "ReadOnly", "AllowNone", "MaxLength", "Precision", "EnumName", "RefDTOName", "RefShowField", "RefDataSource", "RefWhere", "DefaultValue", "RowWidth", "IsNegativeFormat", "TabID", "GroupID", "IsTitle", "IsRecord", "Format", "RelationFields", "IsDetail", "Expression"],
			"TemplateValue": [
				[1376, "Customer", "客户", "Customer", "RefComplexBox", "DTO", false, false, 100, 3, "", "PartnerDTO", "", "RefPartnerDTO", null, "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1378, "Memo", "备注", "Memo", "TextBox", "String", false, true, 200, 3, "", "", "", "RefDtoName", null, "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1377, "SettleCustomer_ARBalance", "应收余额", "ARBalance", "NumTextBox", "Decimal", true, true, 13, 2, "", "", "", "", null, "", 0.00, false, 41, 208, false, false, "", "SettleCustomer", false, null],
				[1383, "Warehouse", "仓库", "Warehouse", "RefComplexBox", "DTO", false, true, 0, 3, "", "WarehouseDTO", "", "MBRefWarehouseDTO", "Key@Key_RefWarehouseDTO_0002", "", 0.00, false, 41, 208, false, true, "", "", false, null],
				[1379, "VoucherDate", "单据日期", "VoucherDate", "DateDropDown", "DateTime", false, false, 48, 3, "", "", "", "", null, "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1384, "SettleCustomer", "结算客户", "SettleCustomer", "RefComplexBox", "DTO", false, false, 0, 3, "", "PartnerDTO", "", "RefPartnerDTO", null, "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1374, "Address", "到货地址", "Address", "TextComboBox", "DTO", false, true, 200, 3, "", "PartnerAddressDTO", "ShipmentAddress", "MBRefPartnerAddressDTO_ShipmentAddress", "Key@Key_RefPartnerAddressDTO_0002", "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1382, "DeliveryDate", "交货日期", "DeliveryDate", "DateDropDown", "DateTime", false, true, 48, 3, "", "", "", "", null, "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1411, "OrderSettleStyle", "结算方式", "SettleStyle", "RefComboBox", "DTO", false, true, 0, 3, "", "SettleStyleDTO", "", "MBRefSettleStyleDTO", "Key@Key_RefSettleStyleDTO_0002", "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1412, "OrderBankAccount", "账号", "BankAccount", "RefComboBox", "DTO", false, true, 0, 3, "", "BankAccountDTO", "", "MBRefBankAccountDTO", "Key@Key_RefBankAccountDTO_0002", "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1410, "OrigAmount", "订金", "OrigAmount", "NumTextBox", "Decimal", false, true, 13, 2, "", "", "", "", null, "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1381, "Project", "项目", "Project", "RefComplexBox", "DTO", false, true, 0, 3, "", "ProjectDTO", "", "MBRefProjectDTO", "Key@Key_ProjectOnlyTree_0001", "", 0.00, false, 41, 208, false, false, "", "", false, null],
				[1413, "IsUseInventoryWarehouse", "录入存货时优先取默认仓库", "IsUseInventoryWarehouse", "CheckBox", "Bool", false, true, 1, 3, "", "", "", "", null, "0", 0.00, false, 41, 208, false, true, "", "", false, null],
				[3111, "Inventory", "存货名称", "Inventory", "RefComplexBox", "DTO", false, false, 200, 3, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3101, "Inventory_Code", "存货编码", "Code", "RefComplexBox", "String", false, false, 50, 3, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3107, "Inventory_Specification", "规格型号", "Specification", "TextBox", "String", true, true, 200, 3, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3104, "InventoryBarCode", "条形码", "InventoryBarCode", "RefComboBox", "String", true, true, 128, 3, "", "InvBarCodeDTO", "", "RefInvBarCodeDTO", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3135, "Inventory_priuserdefdecm1", "存货数值", "priuserdefdecm1", "TextBox", "Decimal", true, true, 100, 2, "", "InventoryDTO", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3136, "Inventory_priuserdefnvc1", "存货字符1", "priuserdefnvc1", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3140, "Inventory_priuserdefnvc2", "存货字符2", "priuserdefnvc2", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3137, "Inventory_priuserdefnvc3", "存货字符3", "priuserdefnvc3", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3139, "Inventory_priuserdefnvc4", "存货字符4", "priuserdefnvc4", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3141, "Inventory_priuserdefnvc5", "存货字符5", "priuserdefnvc5", "TextBox", "String", true, true, 60, 0, "", "InventoryDTO", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3106, "ExistingQuantity", "现存量", "ExistingQuantity", "NumTextBox", "String", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3108, "AvailableQuantity", "可用量", "AvailableQuantity", "NumTextBox", "String", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3152, "freeitem0", "颜色", "freeItem0", "RefComplexBox", "String", false, true, 50, 3, "enumfreeitem0", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3151, "freeitem1", "尺码", "freeItem1", "RefComplexBox", "String", false, true, 50, 3, "enumfreeitem1", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3100, "Unit", "销售单位", "Unit", "RefComboBox", "DTO", false, false, 50, 3, "", "UnitDTO", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3113, "Warehouse", "仓库", "Warehouse", "DropDownComboBox", "DTO", false, true, 0, 3, "", "WarehouseDTO", "", "MBRefWarehouseDTO", "Key@Key_RefWarehouseDTO_0002", "", 0, false, 66, 0, false, false, "", null, true, null],
				[3102, "Quantity", "数量", "Quantity", "NumTextBox", "Decimal", false, false, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3102, "UnitExchangeRate", "换算率", "UnitExchangeRate", "NumTextBox", "Decimal", false, false, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3112, "Retailprice", "零售价", "Retailprice", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "Retailprice", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3117, "LowestSalePrice", "最低售价", "LowestSalePrice", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3115, "LatestCost", "结存成本", "LatestCost", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3116, "LatestSaleOrigTaxPrice", "最新售价", "LatestSaleOrigTaxPrice", "NumTextBox", "Decimal", true, true, 9, 2, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3109, "IsPresent", "赠品", "IsPresent", "CheckBox", "Bool", false, true, 5, 3, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3105, "OrigTaxPrice", "单价", "OrigTaxPrice", "NumTextBox", "Decimal", false, true, 9, 2, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3103, "OrigTaxAmount", "金额", "OrigTaxAmount", "NumTextBox", "Decimal", true, true, 13, 2, "", "", "", "RefDtoName", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3114, "DetailMemo", "备注", "DetailMemo", "TextBox", "String", false, true, 200, 3, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3110, "Project", "项目", "Project", "RefComplexBox", "DTO", false, true, 0, 3, "", "ProjectDTO", "", "MBRefProjectDTO", "Key@Key_ProjectOnlyTree_0001", "", 0, false, 66, 0, false, false, "", null, true, null],
				[3154, "OrderQuantity", "订货量", "OrderQuantity", "TextBox", "String", true, true, 200, 3, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3155, "DeliveryQuantity", "销货量", "DeliveryQuantity", "TextBox", "String", true, true, 200, 3, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3156, "OutStockQuantity", "出库量", "OutStockQuantity", "TextBox", "String", true, true, 200, 3, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3157, "InvoiceQuantity", "开票量", "InvoiceQuantity", "TextBox", "String", true, true, 200, 3, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3158, "BackAmount", "回款", "BackAmount", "TextBox", "String", true, true, 200, 3, "", "", "", "", null, "", 0, false, 66, 0, false, false, "", null, true, null],
				[3160, "Inventory_Code", "存货编码", "Code", "RefComplexBox", "String", false, false, 50, 3, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3168, "Inventory", "存货名称", "Inventory", "RefComplexBox", "DTO", false, false, 200, 3, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3169, "Inventory_ImageFile", "存货图片", "ImageFile", "ImageColumn", "String", true, true, 500, 3, "", "", "ImageFile", "", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3159, "Unit", "销售单位", "Unit", "RefComboBox", "DTO", false, false, 50, 3, "", "UnitDTO", "", "RefDtoName", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3161, "Quantity", "数量", "Quantity", "NumTextBox", "Decimal", false, false, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3163, "OrigTaxPrice", "单价", "OrigTaxPrice", "NumTextBox", "Decimal", false, true, 9, 2, "", "", "", "RefDtoName", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3164, "ExistingQuantity", "现存量", "ExistingQuantity", "NumTextBox", "Decimal", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3166, "AvailableQuantity", "可用量", "AvailableQuantity", "NumTextBox", "Decimal", true, true, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 67, 0, false, false, "", null, true, null],
				[3182, "Inventory", "存货名称", "Inventory", "RefComplexBox", "DTO", false, false, 200, 3, "", "InventoryDTO", "", "RefInventoryDTO", null, "", 0, false, 68, 0, false, false, "", null, true, null],
				[3174, "Unit", "销售单位", "Unit", "RefComboBox", "DTO", false, false, 50, 3, "", "UnitDTO", "", "RefDtoName", null, "", 0, false, 68, 0, false, false, "", null, true, null],
				[3175, "Quantity", "数量", "Quantity", "NumTextBox", "Decimal", false, false, 11, 2, "", "", "", "RefDtoName", null, "", 0, false, 68, 0, false, false, "", null, true, null]
			]
		},
		"PrintTempalte": {
			"Name": "SaleOrderDTO",
			"IsEmptyFiledHide": true,
			"PrinterType": "58mm",
			"PrintCount": 1,
			"GroupField": ["ID", "Name", "OrderIndex"],
			"GroupValue": [
				[10, "Head", 1],
				[11, "Body", 2],
				[12, "Foot", 3]
			],
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["Customer_Name", "客户", "string", true, false, 100.00, 0, 10, false],
				["Customer_Code", "客户编码", "string", true, false, 100.00, 0, 10, false],
				["CustomerPhone", "客户电话", "string", true, false, 100.00, 0, 10, false],
				["Address", "到货地址", "string", true, false, 100.00, 0, 10, false],
				["LinkMan", "联系人", "string", true, false, 100.00, 0, 10, false],
				["ContactPhone", "联系电话", "string", true, false, 100.00, 0, 10, false],
				["Code", "单号", "string", true, false, 100.00, 0, 10, false],
				["VoucherDate", "日期", "datetime", true, false, 100.00, 0, 10, false],
				["SettleCustomer_Name", "结算客户", "string", true, false, 100.00, 0, 10, false],
				["Inventory_Name", "存货名称", "string", true, true, 100.00, 0, 11, false],
				["Unit_Name", "计量单位", "string", true, false, 100.00, 0, 11, false],
				["Quantity", "数量", "decimal", true, false, 100.00, 2, 11, false],
				["OrigTaxPrice", "单价", "decimal", true, false, 100.00, 2, 11, false],
				["OrigTaxAmount", "金额", "decimal", true, false, 100.00, 2, 11, false],
				["TotalQuantity", "总数量", "decimal", true, false, 100.00, 2, 12, false],
				["OrigTaxAmount", "总金额", "decimal", true, false, 100.00, 2, 12, false],
				["Memo", "备注", "string", true, false, 100.00, 0, 12, false],
				["PrintDate", "打印日期", "datetime", true, false, 100.00, 0, 12, false],
				["QRCode", "单据编号", "string", true, false, 100.00, 0, 12, false],
				["Sign", "客户签字", "string", true, false, 100.00, 0, 12, false]
			]
		},
		"RefSetTempalte": [{
			"Name": "MBRefBankAccountDTO",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["Name", "账号名称", "string", false, true, 50.00, 0, 0, false]
			]
		}, {
			"Name": "MBRefPartnerAddressDTO_ShipmentAddress",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["TelephoneNo", "座机", "string", false, false, 50.00, 0, 0, false],
				["MobilePhone", "手机", "string", false, false, 50.00, 0, 0, false],
				["DeliveryMode.Name", "运输方式", "string", false, false, 50.00, 0, 0, false]
			]
		}, {
			"Name": "MBRefProjectDTO",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["Code", "项目编码", "string", false, false, 50.00, 0, 0, false],
				["class.Name", "所属分类", "string", false, false, 50.00, 0, 0, false]
			]
		}, {
			"Name": "MBRefSettleStyleDTO",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": [
				["Code", "结算方式编码", "string", false, false, 50.00, 0, 0, false],
				["Name", "结算方式名称", "string", false, true, 50.00, 0, 0, false],
				["BankAccount.Name", "默认账户", "string", false, false, 50.00, 0, 0, false]
			]
		}, {
			"Name": "MBRefWarehouseDTO",
			"ColSetField": ["Field", "Caption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID", "IsFoot"],
			"ColSetValue": []
		}]
	}]
};

const ReferData ={
		"Table": {
			"Rows": [{
				"VoucherDate" :"2019-11-21",
				"Quantity":"3",
				"Unit":{
					"ID":"1",
					"Name":"瓶"
				},
				"Code":"S0-2018-02-03",
				"DiscountRate":"0.76",
				"OrigTaxPrice":"22",
				"OrigPrice":"30",
			},{
				"VoucherDate" :"2019-11-21",
				"Quantity":"6",
				"Unit":{
					"ID":"1",
					"Name":"瓶"
				},
				"Code":"S0-2018-02-04",
				"DiscountRate":"0.76",
				"OrigTaxPrice":"23",
				"OrigPrice":"32",
			},{
				"VoucherDate" :"2019-11-21",
				"Quantity":"8",
				"Unit":{
					"ID":"1",
					"Name":"瓶"
				},
				"Code":"S0-2018-02-09",
				"DiscountRate":"0.76",
				"OrigTaxPrice":"33",
				"OrigPrice":"35",
			},{
				"VoucherDate" :"2019-11-21",
				"Quantity":"3",
				"Unit":{
					"ID":"1",
					"Name":"瓶"
				},
				"Code":"S0-2018-02-03",
				"DiscountRate":"0.76",
				"OrigTaxPrice":"27",
				"OrigPrice":"19.9",
			},{
				"VoucherDate" :"2019-11-21",
				"Quantity":"3",
				"Unit":{
					"ID":"1",
					"Name":"件"
				},
				"Code":"S0-2018-02-03",
				"DiscountRate":"0.76",
				"OrigTaxPrice":"26",
				"OrigPrice":"19.9",
			}]
		},
		"IsNextPage": {
			"title": "IsNextPage",
			"unit": null,
			"val": true,
			"valtype": "bool"
		}
	}

export default {
  DataTyteTemplate,
  UITemplate,
  ReferData
};
